import styled from 'styled-components';

export const StyledElementsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.main};
  padding: 2.6rem 1.8rem 4.6rem 1.8rem;
  margin-bottom: 1.2rem;
  margin-top: 1.2rem;
  border-radius: 0.6rem;
  box-shadow: ${({ theme }) => theme.boxShadow.light};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 2.6rem 2.6rem 4.6rem 3.2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 2.6rem 2.6rem 4.6rem 4.6rem;
  }
`;

export const StyledSubtitleContainer = styled.div`
  display: flex;
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
  gap: 2.4rem;
`;

export const StyledGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.6rem 2.4rem;
  margin-bottom: 1.9rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 2fr 0.5fr 0.8fr 0.5fr 2fr;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1.5fr 2fr 2fr 1fr 2fr;
  }
`;

const StyledFormControl = styled.div`
  & > div > input:disabled {
    background-color: ${({ theme }) => theme.colors.grey[200]};
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

export const StyledIdField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 1 / 1 / 1 / 3;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 1 / 1 / 1;
  }
`;

export const StyledMachineUrlField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 1 / 3 / 1 / 6;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 2 / 1 / 2;
  }
`;

export const StyledLabelField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 2 / 1 / 2 / 3;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 3 / 1 / 3;
  }
`;

export const StyledLevelField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 2 / 3 / 2 / 4;
    max-width: 8.1rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 4 / 1 / 4;
    max-width: 12.2rem;
  }
`;

export const StyledSecurityGroupField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 2 / 4 / 2 / 6;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 1 / 5 / 1 / 5;
  }
`;

export const StyledStatusField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 3 / 1 / 3 / 3;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 2 / 1 / 2 / 1;
  }
`;

export const StyledAMIField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 3 / 3 / 3 / 6;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 2 / 2 / 2 / 2;
  }
`;

export const StyledInstanceIdField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 4 / 1 / 4 / 2;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 2 / 3 / 2 / 3;
  }
`;

export const StyledPrivateIpField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 4 / 2 / 4 / 4;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 2 / 4 / 2 / 4;
    max-width: 12.2rem;
  }
`;

export const StyledInstanceTypeField = styled(StyledFormControl)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-area: 4 / 4 / 4 / 6;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-area: 2 / 5 / 2 / 5;
  }
`;

export const StyledSubtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  font-size: 2.4rem;
  line-height: 2.758rem;
  color: ${({ theme }) => theme.colors.text.light};
  align-self: center;
`;
